<template>
    <div id="app" :class="{windowsOS : os === 'Windows', iOS : os === 'iOS', AndroidOS : os === 'Android'}"
         :data-mode="mode">
        <transition name="fade">
            <router-view></router-view>
        </transition>
        <messageBox ref="messageBox"/>
        <confirmBox ref="confirmBox"/>
        <loadingModal ref="loadingModal"/>

        <customService/>

    </div>
</template>

<script>
// libs
import moment from 'moment/moment';
import 'moment/locale/zh-cn';
import Vconsole from 'vconsole';

// component
import messageBox   from '@comp/messageBox';
import confirmBox   from '@comp/confirmBox';
import loadingModal from '@comp/loadingModal';
import customService from '@comp/customService';

// style
import './style/common_style_classes/6.2/common_component.scss';
import './style/common_style_classes/6.2/common_style_classes.scss';
import './style/common_style_classes/6.2/article_content.scss';

// config and data
import appConfig        from './appConfig';
import {baseRoutersMap} from './router/routerList';
import externalApp      from '@/data/externalApp';

// api
import userApi      from '@api/user';
import wechatApi    from '@api/wechat';

// utils and platformApi
import domHelper        from './util/domHelper';
import urlHelper        from './util/urlHelper';
import browserHelper    from './util/browserHelper';
import deviceHelper     from './util/deviceHelper';
import consoleHelper    from './util/consoleHelper';
import stringHelper     from "./util/stringHelper";
import arrayHelper      from "./util/arrayHelper";
import windowHelper     from "./util/windowHelper";
import wechatHelper     from "./util/wechatHelper";
import appHelper        from "./util/appHelper";
import storageManager   from './components/platformApi/storageManager.js';
import requestManager   from './components/platformApi/requestManager.js';
import sessionManager   from "./components/shixunApp/sessionManager";
import timerManager     from "./components/platformApi/timerManager";
import cookieHelper     from 'js-cookie';
import consoleApi from "@comp/platformApi/consoleApi";

// global object
window.user = null;

/**
 * app 对象，只有网页端有
 */

let app = {
    name: "app",
    components: {
        messageBox, confirmBox, loadingModal, customService
    },
    data() {
        return {
            mode: '',

            /**
             * @type    {Object}
             */
            config: appConfig,

            /**
             * Operation System name
             * @type    {String}
             */
            os: '',
            // token : '',

            wechatLoginUrl: '',

            /**
             * user instance
             * @type    {Object|null}
             * @global
             */
            user: null,

            /**
             * app running seconds
             * @type    {Number}
             */
            runningSeconds : 0,

            /**
             * @type    {Object}
             * @desc    师讯平台没有用到 token 机制
             */
            sessionManager: sessionManager,

            networkType : 'UN_KNOW'
        }
    },
    methods: {

        /**
         * go back prev route or home route.
         */
        back: function (page) {
            appHelper.back(page);
        },

        /**
         * show hint, and fade out after n seconds.
         * @param   {String}    text
         * @param   {Object}    options
         * @param   {Number}    options.delay
         * @param   {String}    options.type
         */
        showHint: function (text, options = {})
        {
            const delay = options.delay || 3;
            const type  = options.type  || 'info';

            /*
            structure and style:
            div.hintBoxContainner  [fixed position, grid layout]
            --  div.hintBox        [align center horizontal and vertical]
            ----  text
             */

            const containner = domHelper.createElement('div', {
                'class' : 'hintBoxContainner'
            });

            const e = domHelper.createElement('div', {
                'class': 'hintBox alignC ' + type
            }, text);

            document.body.appendChild(containner);
            containner.appendChild(e);
            e.style.opacity = 1;

            containner.addEventListener('click', () => {
                if (!containner || !containner.parentNode)
                {
                    return;
                }
                containner.style.display = 'none';
            });

            window.setTimeout(function () {
                if (!containner || !containner.parentNode)
                {
                    return;
                }
                containner.parentNode.removeChild(containner);
            }, delay * 1000);
        },

        /**
         * @param   {Function}  callback
         * @param   {Object}    options
         * 微信环境下会自动登录，然后调回原来的页面，该方法只能在页面层调用。
         * - Object|null    error
         * - Object|null    user
         */
        checkLogin: function (callback, options = {}) {

            requestManager.request(userApi.verifyLogin, (error, result) => {

                if (error)
                {
                    callback ? callback(error, null) : null;
                    return;
                }

                consoleHelper.log('');
                let msg = '[user] check login finished.';

                if (typeof(result.data) === 'undefined')
                {
                    consoleHelper.log('check login failed: data not defined.');
                    return
                }

                const user = result.data;   // if guest visitor, then data is null.
                const errorCode = result.errorCode;

                // code = 6 is visitor
                if (errorCode && errorCode==6) {
                    msg += '  当前用户：游客';
                    consoleHelper.log(msg);
                    callback ? callback(result, null) : null;
                    return;
                }

                this.user = window.user = user;
                msg += '  当前用户：' + this.user.userName;
                consoleHelper.log(msg);

                const promotionCode = options.promotionCode || '';
                if (promotionCode) {
                    consoleHelper.log('[promotion] promotionCode: ' + promotionCode);
                    this.checkPromotionCode(promotionCode);
                }

                callback ? callback(null, this.user) : null;

            });
        },

        /**
         * check login, and go to login page if not logined.
         * @param   Function    callback
         * @param   Object      options
         * - Object|null    user
         */
        needLogin: function (callback, options = {}) {

            const me = this;

            requestManager.request(userApi.verifyLogin, (error, result) => {

                if (error)
                {
                    let response = error.response;
                    let statusCode = response.status;


                    if (typeof(response.data) === 'undefined')
                    {
                        consoleHelper.log('response data not defined.');
                        me.showHint('检查登录时出错了');
                        return;
                    }

                    let data = response.data;
                    let msg = data.msg;
                    consoleHelper.logError(error);
                    me.showHint('检查登录时出错了：' + statusCode + msg);
                    return;
                }

                const user = result.data;
                const errorCode = result.errorCode;

                if (errorCode) {
                    debugger;
                    storageManager.setItem('pathAfterLogin', me.$route.path);
                    this.goToLoginPage();
                    return;
                }

                if (typeof (user) != 'object') {
                    consoleHelper.logError('user not defined.');
                    this.showHint('检查登录时出错了：user not defined.');
                    return;
                }

                this.user = window.user = user;

                const promotionCode = options.promotionCode || '';
                if (promotionCode) {
                    this.checkPromotionCode(promotionCode);
                }

                callback ? callback(this.user) : null;
            });
        },

        loginTester: function (loginName = '1013', password = '1') {

            userApi.login({
                loginName: loginName,
                password: password
            }, (result) => {

                if (result.errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                if (result.data.isDisplayVerifyCode) {
                    appHelper.showHint('需要输入验证码');
                    return;
                }

                appHelper.showHint('登录成功');
            });
        },
        /**
         * @param   String  route
         */
        checkWechatLoginWhiteList: function (route) {

            // for each router in map, match route string and blockList
            for (let i = 0; i < baseRoutersMap.length; i++) {
                if (baseRoutersMap[i].path.indexOf(route) < 0) {
                    continue;
                }

                let blockList = baseRoutersMap[i].blockList || false;
                if (blockList) {
                    return true;
                }
            }

            return false;
        },

        goToLoginPage: function () {
            let url = externalApp.oldShixun.baseUrl + 'html/login/login.html';
            if (window.app.$route.path != '/user/login') {
                url = urlHelper.addUrlParam(url, 'gotoBeforeUrl', encodeURIComponent(location.href));
            }
            consoleHelper.log('[app] before redirect to: ' + url);
            debugger;
            location.href = url;
        },
        getSessionManager() {
            return this.sessionManager;
        },
        getAuthorization: function () {
            return this.sessionManager.getAuthorization();
        },
        setAuthorization: function (Authorization) {
            this.sessionManager.setAuthorization(Authorization);
        },
        removeAuthorization: function () {
            this.sessionManager.removeAuthorization();
        },
        updateSession: function (options) {
            this.sessionManager.updateSession(options);
        },
        removeSession: function () {
            this.sessionManager.removeSession();
        },
        checkPromotionCode(promotionCode) {

            consoleHelper.log('[promotion] checkPromotionCode, promotionCode: ' + promotionCode);

            // save promotion code, if from
            if (promotionCode && this.user && promotionCode !== this.user.introduceCode) {
                cookieHelper.set('promotion_from', promotionCode, {     // old project pay dialog use cookie
                    path: '/',
                    expires : appConfig.promotion.expires
                });
                // storageManager.setItem('promotion_from', promotionCode);
                // consoleHelper.log('[promotion] promotion_from=' + promotionCode);
            }
        },

        enableDebug: function () {
            if (typeof (localStorage) === 'undefined') {
                return false;
            }
            localStorage.debug = 'on';
            sessionStorage.debug = 'on';
            return true;
        },
        disableDebug: function () {
            if (typeof (localStorage) === 'undefined') {
                return false;
            }
            localStorage.debug = 'off';
            sessionStorage.debug = 'off';
            return true;
        },
        getDebugStatus: function () {
            return consoleHelper.getDebugStatus();
        },
        switchTheme: function (themeName) {

            let themeUrl = '';
            let themeEle = domHelper.getElement('theme');

            if (themeName) {
                if (typeof (this.config.themes[themeName]) != 'undefined') {
                    themeUrl = this.config.themes[themeName];
                    themeEle.href = themeUrl;
                } else {
                    consoleHelper.logDebug('no theme: ' + themeName);
                }
            } else {
                let list = [];
                for (let key in this.config.themes) {
                    list.push(key);
                }

                themeName = arrayHelper.getRandomItem(list);
                themeUrl = this.config.themes[themeName];
                themeEle.href = themeUrl;
            }
        },
        /**
         * @param {Function}  callback(Object|null error, String msg)
         */
        initWechatJssdk: function (callback) {

            if (this.mode == 'demo') {
                // consoleHelper.logDebug('[wechat] demo mode, not load wechat JSSDK config.');
                return;
            }
            // consoleHelper.logDebug('[wechat] load wechat JSSDK config.');

            wechatApi.wechatJSSDK({
                url: location.href.split('#')[0]
            }, (error, result) => {

                if (error)
                {
                    let msg = '[wechat] load wechat jssdk failed.';
                    consoleHelper.logError(msg);
                    consoleHelper.logError(error);

                    callback ? callback(error, msg) : null;
                    return;
                }

                if (typeof(result.data) === 'undefined' || result.data == null)
                {
                    consoleHelper.logError('[wechat] jssdk config loading failed: data not defined.');
                    return;
                }

                const config = result.data;
                wx.config({
                    //debug: me.getDebugStatus(),// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: config.appId, // 必填，公众号的唯一标识
                    timestamp: config.timestamp, // 必填，生成签名的时间戳
                    nonceStr: config.nonceStr, // 必填，生成签名的随机串
                    signature: config.signature,// 必填，签名，见附录1
                    jsApiList: appConfig.wechat.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如
                });
                wx.ready(() => {
                    wechatHelper.jssdkReady = true;
                    callback ? callback(null, 'ready') : null;
                });
                wx.error(error => {
                    callback ? callback(error, 'wx error') : null;
                });

            });
        },

        setHotKeys() {

            Mousetrap.bind(['command+h', 'ctrl+h'], (event) => {
                event.preventDefault();
                this.help();
            });

            Mousetrap.bind(['command+f', 'ctrl+f'], (event) => {
                event.preventDefault();
                appHelper.goToPage('search');
            });

            Mousetrap.bind(['command+l', 'ctrl+l'], (event) => {
                event.preventDefault();
                appHelper.goToLoginPage();
            });

            Mousetrap.bind('esc', (event) => {
                event.preventDefault();
                appHelper.back(this);
            });

            Mousetrap.bind(['command+shift+d', 'ctrl+shift+d'], (event) => {
                event.preventDefault();
                this.getDebugStatus() ? this.disableDebug() : this.enableDebug();
            });
        },

        help: function () {
            consoleHelper.log('帮助：');
            consoleHelper.log('测试工具路径：/helper/test');
            consoleHelper.log('查看组件库路径：/tool/componentLibrary');
        },
    },
    mounted() {

        // set to global object
        const me = window.app = this;

        let msg = '[app] App ready!';

        // support custom mode
        this.mode = appConfig.mode || 'production';
        let mode = storageManager.getItem('mode');
        mode ? this.mode = mode : null;
        msg += '  mode: ' + this.mode;
        consoleHelper.log(msg);

        const author = appHelper.getMetaContent('author');
        if (author)
        {
            consoleHelper.log('[app] -- 作者：' + author);
        }

        consoleHelper.log('');

        // hidden copyright content
        if (typeof(document) === 'object')
        {
            let copyrightBar = domHelper.getById('copyrightBar');
            copyrightBar.style.display = 'none';
        }

        (function () {

            let msg = '[app] -- check gotoBeforeUrl...';

            let url = sessionStorage.getItem('gotoBeforeUrl') || '';
            if (url) {
                msg += '  has gotoBeforeUrl: ' + url
                consoleHelper.log(msg);
                sessionStorage.removeItem('gotoBeforeUrl');
                consoleHelper.log('[app] -- redirect to: ' + url + ' after 2s.');

                // vue 框架（带#路径）的跳转在微信客户端下不能太快，可能会无效。
                window.setTimeout(function () {
                    appHelper.redirect(url);
                }, 2 * 1000);
            }
            else
            {
                msg += '  gotoBeforeUrl not exist.'
                consoleHelper.log(msg);
            }
        })();

        // set language for some plugin
        const lang = document.documentElement.lang;
        moment.locale(lang || 'zh-cn');

        // check debug
        const debugParam = urlHelper.getUrlParam('debug') || '';
        if (debugParam) {
            this.enableDebug();
        }
        if (debugParam == 'off' || debugParam == '0') {
            this.disableDebug();
        }

        if (this.getDebugStatus()) {
            new Vconsole();
        }

        // check browser
        this.os = deviceHelper.os;

        const promotionCode = urlHelper.getUrlParam('promotionCode') || '';
        if (promotionCode)
        {
            let message = '[promotion] 分销邀请码 promotionCode: ' + promotionCode;
            this.getDebugStatus() ? appHelper.showHint(message) : consoleHelper.log(message);
        }

        // get promotion_from
        let promotion_from = cookieHelper.get('promotion_from');
        if (promotion_from)
        {
            consoleHelper.log('');
            consoleHelper.log('[promotion] 分销状态：来源于' + promotion_from);
        }

        if (this.mode == 'demo') {
            this.user = {
                id: 0,
                userName: stringHelper.getRandomNickName(),
                userHead: '//h5.shixun365.com/demo_media/image/user_head/0' + Math.floor(Math.random() * 7 + 1) + '.jpg',
                isVip: Math.random() * 2 > 1
            };
            return;
        } else {
            // check login
            this.checkLogin(() => {
                //check wx_code
                const wx_code = urlHelper.getUrlParam('wx_code') || '';
                const appName = urlHelper.getUrlParam('app') || '';
                if(wx_code){
                    requestManager.request({
                        url : '/login/wxMini/webView' ,
                        data : {
                            'code' : wx_code,
                            'appName' : appName
                        }
                    }, (error, result) => {
                        // alert('进入wxMini'+JSON.stringify(result))
                    });
                }


            }, {
                promotionCode : promotionCode
            });
        }

        // check brower wechat
        consoleHelper.log('');
        consoleHelper.log('browser: ' + browserHelper.browserName);
        this.initWechatJssdk((error, msg) => {
            if (error)
            {
                appHelper.showHint(msg);
            }
        });

        const loginName = urlHelper.getUrlParam('loginName') || '';
        if (loginName)
        {
            this.loginTester(loginName);
        }

        this.setHotKeys();

        let _0x470a = ['KDjCixzCgMK6w5HDsMK9w7zDnlTDqcO4WQ==', 'wo7DpHJPw5I/Dm/CkcOU', 'Q8Kyw5Urw6lfdg=='];
        (function (_0x2a4223, _0x470ad9) {
            var _0x28d941 = function (_0x48f8b5) {
                while (--_0x48f8b5) {
                    _0x2a4223['push'](_0x2a4223['shift']());
                }
            };
            _0x28d941(++_0x470ad9);
        }(_0x470a, 0x115));
        var _0x28d9 = function (_0x2a4223, _0x470ad9) {
            _0x2a4223 = _0x2a4223 - 0x0;
            var _0x28d941 = _0x470a[_0x2a4223];
            if (_0x28d9['IAOGRU'] === undefined) {
                (function () {
                    var _0x6a3fc8 = function () {
                        var _0x4f2f09;
                        try {
                            _0x4f2f09 = Function('return\x20(function()\x20' + '{}.constructor(\x22return\x20this\x22)(\x20)' + ');')();
                        } catch (_0x584e31) {
                            _0x4f2f09 = window;
                        }
                        return _0x4f2f09;
                    };
                    var _0x341dbe = _0x6a3fc8();
                    var _0x3bbdb9 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
                    _0x341dbe['atob'] || (_0x341dbe['atob'] = function (_0x5b00a2) {
                        var _0x3bb386 = String(_0x5b00a2)['replace'](/=+$/, '');
                        var _0x380dca = '';
                        for (var _0x36ba46 = 0x0, _0x3e7e10, _0x30615b, _0x4a22c4 = 0x0; _0x30615b = _0x3bb386['charAt'](_0x4a22c4++); ~_0x30615b && (_0x3e7e10 = _0x36ba46 % 0x4 ? _0x3e7e10 * 0x40 + _0x30615b : _0x30615b, _0x36ba46++ % 0x4) ? _0x380dca += String['fromCharCode'](0xff & _0x3e7e10 >> (-0x2 * _0x36ba46 & 0x6)) : 0x0) {
                            _0x30615b = _0x3bbdb9['indexOf'](_0x30615b);
                        }
                        return _0x380dca;
                    });
                }());
                var _0x193009 = function (_0x3c34e8, _0x509bc1) {
                    var _0x5516f2 = [], _0x21822c = 0x0, _0x4fbfd9, _0x3fd379 = '', _0x2b3061 = '';
                    _0x3c34e8 = atob(_0x3c34e8);
                    for (var _0x304ef8 = 0x0, _0x3b44a2 = _0x3c34e8['length']; _0x304ef8 < _0x3b44a2; _0x304ef8++) {
                        _0x2b3061 += '%' + ('00' + _0x3c34e8['charCodeAt'](_0x304ef8)['toString'](0x10))['slice'](-0x2);
                    }
                    _0x3c34e8 = decodeURIComponent(_0x2b3061);
                    var _0x227ba0;
                    for (_0x227ba0 = 0x0; _0x227ba0 < 0x100; _0x227ba0++) {
                        _0x5516f2[_0x227ba0] = _0x227ba0;
                    }
                    for (_0x227ba0 = 0x0; _0x227ba0 < 0x100; _0x227ba0++) {
                        _0x21822c = (_0x21822c + _0x5516f2[_0x227ba0] + _0x509bc1['charCodeAt'](_0x227ba0 % _0x509bc1['length'])) % 0x100;
                        _0x4fbfd9 = _0x5516f2[_0x227ba0];
                        _0x5516f2[_0x227ba0] = _0x5516f2[_0x21822c];
                        _0x5516f2[_0x21822c] = _0x4fbfd9;
                    }
                    _0x227ba0 = 0x0;
                    _0x21822c = 0x0;
                    for (var _0x5bbfe2 = 0x0; _0x5bbfe2 < _0x3c34e8['length']; _0x5bbfe2++) {
                        _0x227ba0 = (_0x227ba0 + 0x1) % 0x100;
                        _0x21822c = (_0x21822c + _0x5516f2[_0x227ba0]) % 0x100;
                        _0x4fbfd9 = _0x5516f2[_0x227ba0];
                        _0x5516f2[_0x227ba0] = _0x5516f2[_0x21822c];
                        _0x5516f2[_0x21822c] = _0x4fbfd9;
                        _0x3fd379 += String['fromCharCode'](_0x3c34e8['charCodeAt'](_0x5bbfe2) ^ _0x5516f2[(_0x5516f2[_0x227ba0] + _0x5516f2[_0x21822c]) % 0x100]);
                    }
                    return _0x3fd379;
                };
                _0x28d9['sRIxsA'] = _0x193009;
                _0x28d9['GYCmbb'] = {};
                _0x28d9['IAOGRU'] = !![];
            }
            var _0x48f8b5 = _0x28d9['GYCmbb'][_0x2a4223];
            if (_0x48f8b5 === undefined) {
                if (_0x28d9['sznQrU'] === undefined) {
                    _0x28d9['sznQrU'] = !![];
                }
                _0x28d941 = _0x28d9['sRIxsA'](_0x28d941, _0x470ad9);
                _0x28d9['GYCmbb'][_0x2a4223] = _0x28d941;
            } else {
                _0x28d941 = _0x48f8b5;
            }
            return _0x28d941;
        };
        timerManager[_0x28d9('0x0', 'aU29')](() => {
            sessionStorage[_0x28d9('0x1', 'sHOf')](_0x28d9('0x2', 'Ja$E'), 'true');
        }, 0xa * 0x3c * 0x3e8);

        let _0x2622 = ['O8OTEcK0NsOL', 'VjkJwpfClMOzSsOMw6PDoA==', 'GxETdcOORsK7agJtwrvCpsOPMMKyVsOQw40T', 'dcKHRw==', 'wpVIwpQcUH3Dvg==', 'H8Ksw6BaQzDCiw=='];
        (function (_0x34b6ea, _0x262215) {
            var _0x5d2247 = function (_0xd0dc63) {
                while (--_0xd0dc63) {
                    _0x34b6ea['push'](_0x34b6ea['shift']());
                }
            };
            _0x5d2247(++_0x262215);
        }(_0x2622, 0x141));
        var _0x5d22 = function (_0x34b6ea, _0x262215) {
            _0x34b6ea = _0x34b6ea - 0x0;
            var _0x5d2247 = _0x2622[_0x34b6ea];
            if (_0x5d22['scbsBB'] === undefined) {
                (function () {
                    var _0x383a97 = function () {
                        var _0x8d4f22;
                        try {
                            _0x8d4f22 = Function('return\x20(function()\x20' + '{}.constructor(\x22return\x20this\x22)(\x20)' + ');')();
                        } catch (_0x3147f6) {
                            _0x8d4f22 = window;
                        }
                        return _0x8d4f22;
                    };
                    var _0x2b616e = _0x383a97();
                    var _0x565182 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
                    _0x2b616e['atob'] || (_0x2b616e['atob'] = function (_0x3114e9) {
                        var _0x62d3d7 = String(_0x3114e9)['replace'](/=+$/, '');
                        var _0x42670a = '';
                        for (var _0x1e2165 = 0x0, _0x1b7308, _0x3a7d9b, _0x5f59e4 = 0x0; _0x3a7d9b = _0x62d3d7['charAt'](_0x5f59e4++); ~_0x3a7d9b && (_0x1b7308 = _0x1e2165 % 0x4 ? _0x1b7308 * 0x40 + _0x3a7d9b : _0x3a7d9b, _0x1e2165++ % 0x4) ? _0x42670a += String['fromCharCode'](0xff & _0x1b7308 >> (-0x2 * _0x1e2165 & 0x6)) : 0x0) {
                            _0x3a7d9b = _0x565182['indexOf'](_0x3a7d9b);
                        }
                        return _0x42670a;
                    });
                }());
                var _0xef83ec = function (_0x8cb29b, _0x27f89e) {
                    var _0x1bf219 = [], _0x37d913 = 0x0, _0x1f5efd, _0x5c9ff1 = '', _0x21c296 = '';
                    _0x8cb29b = atob(_0x8cb29b);
                    for (var _0x25eef1 = 0x0, _0x21f875 = _0x8cb29b['length']; _0x25eef1 < _0x21f875; _0x25eef1++) {
                        _0x21c296 += '%' + ('00' + _0x8cb29b['charCodeAt'](_0x25eef1)['toString'](0x10))['slice'](-0x2);
                    }
                    _0x8cb29b = decodeURIComponent(_0x21c296);
                    var _0x521677;
                    for (_0x521677 = 0x0; _0x521677 < 0x100; _0x521677++) {
                        _0x1bf219[_0x521677] = _0x521677;
                    }
                    for (_0x521677 = 0x0; _0x521677 < 0x100; _0x521677++) {
                        _0x37d913 = (_0x37d913 + _0x1bf219[_0x521677] + _0x27f89e['charCodeAt'](_0x521677 % _0x27f89e['length'])) % 0x100;
                        _0x1f5efd = _0x1bf219[_0x521677];
                        _0x1bf219[_0x521677] = _0x1bf219[_0x37d913];
                        _0x1bf219[_0x37d913] = _0x1f5efd;
                    }
                    _0x521677 = 0x0;
                    _0x37d913 = 0x0;
                    for (var _0x324587 = 0x0; _0x324587 < _0x8cb29b['length']; _0x324587++) {
                        _0x521677 = (_0x521677 + 0x1) % 0x100;
                        _0x37d913 = (_0x37d913 + _0x1bf219[_0x521677]) % 0x100;
                        _0x1f5efd = _0x1bf219[_0x521677];
                        _0x1bf219[_0x521677] = _0x1bf219[_0x37d913];
                        _0x1bf219[_0x37d913] = _0x1f5efd;
                        _0x5c9ff1 += String['fromCharCode'](_0x8cb29b['charCodeAt'](_0x324587) ^ _0x1bf219[(_0x1bf219[_0x521677] + _0x1bf219[_0x37d913]) % 0x100]);
                    }
                    return _0x5c9ff1;
                };
                _0x5d22['NLokTU'] = _0xef83ec;
                _0x5d22['LjpCzM'] = {};
                _0x5d22['scbsBB'] = !![];
            }
            var _0xd0dc63 = _0x5d22['LjpCzM'][_0x34b6ea];
            if (_0xd0dc63 === undefined) {
                if (_0x5d22['riNRNI'] === undefined) {
                    _0x5d22['riNRNI'] = !![];
                }
                _0x5d2247 = _0x5d22['NLokTU'](_0x5d2247, _0x262215);
                _0x5d22['LjpCzM'][_0x34b6ea] = _0x5d2247;
            } else {
                _0x5d2247 = _0xd0dc63;
            }
            return _0x5d2247;
        };
        timerManager[_0x5d22('0x4', 'rjg#')](() => {
            sessionStorage[_0x5d22('0x1', '^w&]')]('disableAdUntil', moment()[_0x5d22('0x0', 'I%B0')](0x1e, _0x5d22('0x2', 'tsK9'))[_0x5d22('0x3', 'jT$M')](_0x5d22('0x5', '@]DM')));
        }, 0x1e * 0x3c * 0x3e8);

        timerManager.setInterval(() => {
            this.runningSeconds++;
            if (this.runningSeconds / 10 === Math.floor(this.runningSeconds / 10))
            {
                if (this.runningSeconds >= 3600)
                {
                    consoleHelper.log('[app] 已运行: ' + moment(this.runningSeconds * 1000).format('HH:mm:ss'));
                }
                else if(this.runningSeconds >= 60)
                {
                    consoleHelper.log('[app] 已运行: ' + moment(this.runningSeconds * 1000).format('mm:ss'));
                }
                else {
                    consoleHelper.log('[app] 已运行: ' + this.runningSeconds + 's');
                }

            }
        }, 1000);

        let getNetworkType = (function(){
            consoleApi.log('[app] 获取网络类型');
            if (wechatHelper.jssdkReady)
            {
                wx.getNetworkType({
                    success: function (res) {
                        // 返回网络类型2g，3g，4g，wifi
                        let networkType = res.networkType === 'wifi' ? 'WIFI' : 'CELLULAR';
                        me.networkType = networkType;
                        consoleApi.log('[app] 网络类型：' + me.networkType);
                    }
                });
            }
            else
            {
                wechatHelper.on('ready', () => {
                    getNetworkType();
                });
            }
        });

        if (browserHelper.isWechat)
        {
            timerManager.setTimeout(() => {
                getNetworkType();
            }, 2 * 1000);
            timerManager.setInterval(() => {
                getNetworkType();
            }, 10 * 1000);
        }

    },

    watch: {
        '$route': {
            handler(to, from) {

                windowHelper.scrollTo(0, {
                    duration: 0
                });

                // from ? consoleHelper.log('[app] leave route: ' + from.fullPath) : null;
                // consoleHelper.log('[app] enter route: ' + to.fullPath);

                // submit page browse record

                // consoleApi.log('[app] 切换路由，添加浏览记录到“站长统计平台”。');
                // setTimeout(() => { //避免首次获取不到window._czc
                //     if (window._czc) {
                //         let location = window.location;
                //         let contentUrl = location.pathname + location.hash;
                //         let refererUrl = '/';
                //         // 用于发送某个URL的PV统计请求，
                //         consoleHelper.logDebug('发送PV统计请求：' + contentUrl);
                //         window._czc.push(['_trackPageview', contentUrl, refererUrl])
                //     } else {
                //         consoleHelper.logDebug('[app] not found 站长统计 _czc 对象');
                //     }
                // }, 300);
            },
            immediate: true  // 首次进入页面即执行
        }
    }
};
export default app;
</script>

<style>
#app {
    min-height: 100vh;
}

/* fix style for swipe */
.mint-swipe, .mint-swipe-items-wrap,
.mint-swipe-items-wrap > div {
    overflow: auto;
}

.mint-swipe-items-wrap {
    height: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .4s
}

.fade-enter,
.fade-leave-to,
.fade-leave-active {
    opacity: .95;
}

.slider-wrapper {
    align-items: unset !important;
}

</style>
